// extracted by mini-css-extract-plugin
module.exports = {"minHeight":"PitchingSummary_minHeight_25P0c","teamLogoUrl":"PitchingSummary_teamLogoUrl_jCZUy"};